import React, { FC, PropsWithChildren } from 'react';

type GlobeProps = {
  /** The color of the icon. */
  color?: string;
};

const Globe: FC<PropsWithChildren<GlobeProps>> = ({ color = 'currentcolor' }) => (
  <svg
    version="1.1"
    viewBox="0 0 20 20"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    y="0px"
  >
    <g>
      <path
        d="M10,1.4c-4.8,0-8.6,3.9-8.6,8.6s3.9,8.6,8.6,8.6s8.6-3.9,8.6-8.6S14.8,1.4,10,1.4z M2.4,10
		c0-0.7,0.1-1.5,0.3-2.2c0.3,0.7,0.7,1.3,1.1,2c0.4,0.8,1.3,0.6,1.8,1.3c0.4,0.6,0,1.4,0.3,2.1c0.2,0.5,0.7,0.6,1,0.9
		c0.3,0.4,0.3,0.8,0.4,1.3c0.1,0.5,0.2,1.1,0.3,1.6c0,0,0,0.1,0,0.1C4.6,16.2,2.4,13.4,2.4,10z M10,17.6c-0.4,0-0.8,0-1.3-0.1
		c0-0.1,0-0.3,0-0.4c0.1-0.6,0.4-1.2,0.8-1.7c0.4-0.5,1-0.8,1.3-1.3c0.3-0.5,0.4-1.2,0.3-1.8c-0.2-0.9-1.4-1.2-2-1.6
		C8.8,10.4,8.5,10,8,10c-0.2,0-0.4,0-0.6,0C7.2,9.9,7,9.8,6.8,9.8c-0.4,0.1-0.7,0.5-1.1,0.4c-0.4-0.1-0.8-0.5-0.9-0.9
		C4.6,8.8,5,8.7,5.5,8.6c0.2,0,0.4,0,0.6,0C6.3,8.7,6.4,8.9,6.6,9C6.9,9.3,7,8.9,7,8.6C6.9,8.1,6.8,7.9,7.2,7.5
		c0.3-0.2,0.6-0.4,0.5-0.8c0-0.3-0.2-0.4,0-0.6c0.1-0.2,0.4-0.4,0.5-0.5c0.5-0.3,1.9-0.3,1.3-1.1C9.4,4.2,9.1,3.8,8.8,3.7
		C8.4,3.7,8.2,4.1,7.9,4.3C7.7,4.5,7.1,4.7,6.8,4.4C6.4,4,7.1,3.9,7.2,3.6C7.3,3.4,7.2,3.2,7,3c0.1-0.1,0.3-0.1,0.4-0.1
		C7.5,2.9,7.7,3,7.8,3c0.3,0,0.5-0.1,0.7,0.1C8.8,3.3,9,3.5,9.3,3.6c0.3,0.1,0.7-0.1,0.7-0.5c0.1-0.2,0-0.5-0.1-0.8
		c1.9,0,3.7,0.7,5,1.9c0,0-0.1,0-0.1,0.1c-0.2,0.2-0.5,0.4-0.6,0.7c-0.1,0.2-0.2,0.3-0.5,0.3c-0.1,0-0.3,0-0.4,0.1
		c-0.3,0.2-0.1,0.8,0.1,0.9c0.3,0.2,0.8,0.1,1.1-0.2c0.2-0.2,0.3-0.6,0.7-0.6c0.2,0,0.3,0.1,0.4,0.2C16,6,16,6.2,16,6.4
		c0.1,0.4,0.5,0.1,0.6-0.1C16.8,6.5,16.9,6.7,17,7c-0.2,0.3-0.4,0.8-0.9,0.4c-0.3-0.2-0.5-0.5-0.8-0.6c-0.3-0.1-0.6,0-1,0.1
		c-0.4,0.1-0.8,0.1-1.1,0.4C13,7.4,12.8,7.8,12.5,8c-0.5,0.5-0.8,1.1-0.4,1.8c0.3,0.7,1,1.1,1.8,1c0.7,0,1.5-0.5,1.5,0.6
		c0,0.4,0.1,0.6,0.2,1c0.1,0.3,0.1,0.6,0.1,1c0,0.4,0.1,0.9,0.2,1.3C14.6,16.5,12.4,17.6,10,17.6z"
        fill={color}
      />
      <path
        d="M13.9,4.8c0.3,0,0.7-0.1,0.6-0.5c-0.1-0.3-0.2-0.7-0.6-0.5c-0.2,0.1-0.6,0.4-0.6,0.7 C13.2,4.8,13.7,4.8,13.9,4.8z"
        fill={color}
      />
    </g>
  </svg>
);

export default Globe;
